module.exports = __webpack_public_path__ + "static/img/netflix-benefit1.8866d01.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/netflix-benefit1.png
// module id = 1075
// module chunks = 1